/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/filter': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22 0H2a1 1 0 00-1 1v3a1 1 0 00.293.707L9 12.414V23a1 1 0 001.6.8l4-3a1 1 0 00.4-.8v-7.586l7.707-7.707A1 1 0 0023 4V1a1 1 0 00-1-1z" _fill="#272c33"/>'
  }
})
